import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from 'ui';
import QuestionBlock from './question-block';

const Container = styled.div`
  width: 100%;
  ${p => p.needsBorderRadius &&
    `
      border-radius: 5px;
      overflow: hidden;
    `}
`;

const Wrapper = styled.div`
    width: 100%;
`;

const PagingDiv = styled.div`
  height: 10px;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  background-color: #C5DBE9;
  cursor: pointer;
  user-select: none;
  ${p => p.isUp ?
    'border-bottom: 1px solid #fff;' :
    'border-top: 1px solid #fff;'};
  &:hover {
    background-color: rgba(0, 152, 190, 0.5);
  }
  i {
    cursor: pointer;
  }
  ${p => p.isUp ?
    'border-radius: 5px 5px 0 0' :
    'border-radius: 0 0 5px 5px'};
`;

// Get the intl object from the parent component
// so we can use this component inside the antd notification
const QuestionSection = ({
  intl,
  questions = [],
  setQuestions,
  maxShownQuestions = 4,
  handleQuestionAnswer,
  handleQuestionUndo,
  hasUnknown = false,
  resetTags,
  canUndo = false,
}) => {
  const needsPaging = questions?.length > maxShownQuestions;

  const handlePaging = (isUp) => {
    setQuestions((state) => {
      const [first, ...rest] = state;
      const [last] = state.slice(-1);
      if (isUp) {
        return [last, ...state.slice(0, -1)];
      }
      return [...rest, first];
    });
  };

  const removeQuestion = (id) => {
    setQuestions(state => state?.filter(q => q.id !== id));
  };

  return (
    <Wrapper>
      {needsPaging ?
        <PagingDiv isUp={true} onClick={() => handlePaging(true)}>
          <Icon type='caret-up' size='sm' />
        </PagingDiv> :
        null
      }
      <Container needsBorderRadius={!needsPaging}>
        {questions
          ?.map((question, i) =>
            <QuestionBlock
              intl={intl}
              key={question?.id}
              {...question}
              visible={i >= 0 && i < maxShownQuestions}
              handleQuestionAnswer={handleQuestionAnswer}
              handleQuestionUndo={handleQuestionUndo}
              removeQuestion={removeQuestion}
              setQuestions={setQuestions}
              hasUnknown={hasUnknown}
              resetTags={resetTags}
              isFirst={i === 0}
              isLast={i === questions.length - 1}
              canUndo={canUndo}
            />,
          )}
      </Container>
      {needsPaging ?
        <PagingDiv onClick={() => handlePaging(false)}>
          <Icon type='caret-down' size='sm' />
        </PagingDiv> :
        null
      }
    </Wrapper>
  );
};
QuestionSection.propTypes = {
  intl: PropTypes.object,
  questions: PropTypes.array,
  maxShownQuestions: PropTypes.number,
  handleQuestionAnswer: PropTypes.func,
  handleQuestionUndo: PropTypes.func,
  setQuestions: PropTypes.func,
  hasUnknown: PropTypes.bool,
  resetTags: PropTypes.bool,
  canUndo: PropTypes.bool,
};

export default QuestionSection;
